import { environment } from 'src/environments/environment';

/**
 * The platform's name on the pages every company sees (sign-up, company setup, driver join). TTO is one customer of
 * the platform, so these pages do not say TTO. One place to change it (or set environment.brandName per build).
 */
export const BRAND = {
  name: ((environment as any).brandName as string | undefined) || 'Paquetly',
  supportEmail: ((environment as any).supportEmail as string | undefined) || null
};
